import type { KeyValueStore } from "./port.ts";

/** Adapter de `localStorage` para a porta de persistência. Tolerante a falhas. */
export class LocalStorageStore implements KeyValueStore {
  read<T>(chave: string, padrao: T): T {
    try {
      const cru = localStorage.getItem(chave);
      return cru === null ? padrao : (JSON.parse(cru) as T);
    } catch {
      return padrao;
    }
  }

  write<T>(chave: string, valor: T): boolean {
    try {
      localStorage.setItem(chave, JSON.stringify(valor));
      return true;
    } catch {
      // Cota cheia / modo privado. Não estoura (o app segue de pé), mas AVISA —
      // quem precisa de durabilidade decide o que fazer.
      return false;
    }
  }

  remove(chave: string): void {
    try {
      localStorage.removeItem(chave);
    } catch {
      // silencioso
    }
  }
}
